import React from 'react';
import classNames from 'classnames';
import { Icon } from '@beisen/chaos-ui';
import * as html from '../util/html';

require('./ToolItemLabel.scss');

/*
    ToolItemLabel: 列表工具栏项目标签
    @label: xxx 标签名
    @type: flex 用于排序或筛选项标签  标签宽度不固定 图标在右侧
    @type: fixed 用于筛选和仪表标签   标签固定宽度 图标在左侧
    @highlight: boolean 是否高亮
    @iconName: 图标名
*/

export default class ToolItemLabel extends React.Component {
    constructor(props) {
        super(props);
        //this.handleTouchLabel = this.handleTouchLabel.bind(this);
    }

    // handleTouchLabel(e) {
    //     e.preventDefault();
    //     this.props.handleTouchLabel && this.props.handleTouchLabel(e);
    // }

    render() {
        const { label, type, highlight, iconName } = this.props;
        return (
            <div
                className={classNames('tool-item-label-container', type, {
                    highlight: highlight
                })}>
                <span className="tool-item-label">
                    {type == 'fixed' ? (
                        <Icon
                            icon={iconName}
                            className={classNames('tool-item-label-icon', type)}
                        />
                    ) : null}
                    {html.decode(label)}
                </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ToolsBar/ToolItemLabel.js